module.exports = __webpack_public_path__ + "img/shield-viking.ee4f6a8d.svg";